module.exports = __webpack_public_path__ + "img/star.cec8a50d.svg";